import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { login } from '../store/authSlice';
import { toast } from 'react-toastify';
import { FiUser, FiMapPin, FiPackage, FiHeart, FiSettings, FiEdit2, FiPlus, FiTrash2 } from 'react-icons/fi';
import './Profile.css';

const TABS = [
  { key: 'profile', label: 'My Profile', icon: FiUser },
  { key: 'orders', label: 'My Orders', icon: FiPackage },
  { key: 'wishlist', label: 'My Wishlist', icon: FiHeart },
  { key: 'address', label: 'Saved Addresses', icon: FiMapPin },
  { key: 'settings', label: 'Account Settings', icon: FiSettings },
];

export default function Profile() {
  const dispatch = useDispatch();
  const { user } = useSelector(s => s.auth);

  useEffect(() => {
    const prev = document.body.style.cssText;
    document.body.style.background = '#ffffff';
    document.body.style.backgroundAttachment = 'unset';
    return () => { document.body.style.background = ''; document.body.style.backgroundAttachment = ''; };
  }, []);
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'profile';
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [editMode, setEditMode] = useState(false);
  const [profileData, setProfileData] = useState({
    name: user?.name || '', email: user?.email || '',
    phone: user?.phone || '', dob: user?.dob || '', gender: user?.gender || '',
  });
  const [addresses, setAddresses] = useState([
    { id: 1, name: 'Priya Sharma', phone: '9876543210', address: '123 MG Road', city: 'Bangalore', state: 'Karnataka', pincode: '560001', type: 'HOME' },
  ]);
  const [showAddAddr, setShowAddAddr] = useState(false);
  const [newAddr, setNewAddr] = useState({ name: '', phone: '', address: '', city: '', state: '', pincode: '', type: 'HOME' });

  const handleSaveProfile = () => {
    dispatch(login({ user: { ...user, ...profileData }, token: localStorage.getItem('token') }));
    setEditMode(false);
    toast.success('Profile updated!');
  };

  const handleAddAddress = () => {
    if (!newAddr.name || !newAddr.address || !newAddr.city || !newAddr.pincode) { toast.error('Fill required fields'); return; }
    setAddresses(p => [...p, { ...newAddr, id: Date.now() }]);
    setNewAddr({ name: '', phone: '', address: '', city: '', state: '', pincode: '', type: 'HOME' });
    setShowAddAddr(false);
    toast.success('Address saved!');
  };

  const handleDeleteAddress = (id) => { setAddresses(p => p.filter(a => a.id !== id)); toast.info('Address removed'); };

  return (
    <div className="profile-page">
      <div className="profile-layout">
        {/* Sidebar */}
        <aside className="profile-sidebar">
          <div className="profile-user-card">
            <div className="profile-avatar-lg">
              <span>{user?.name?.charAt(0)?.toUpperCase() || 'U'}</span>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p className="profile-user-name">{user?.name || 'My Account'}</p>
              <p className="profile-user-email">{user?.email}</p>
            </div>
          </div>
          <div className="profile-stats-row">
            <div className="profile-stat-chip"><strong>3</strong><span>Orders</span></div>
            <div className="profile-stat-chip"><strong>5</strong><span>Wishlist</span></div>
            <div className="profile-stat-chip"><strong>1</strong><span>Address</span></div>
          </div>
          <nav className="profile-nav">
            {TABS.map(tab => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.key}
                  className={`profile-nav-item${activeTab === tab.key ? ' active' : ''}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <Icon /> {tab.label}
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Content */}
        <div className="profile-content">
          {/* Profile Tab */}
          {activeTab === 'profile' && (
            <div className="profile-section-card">
              <div className="section-card-header">
                <h2>Personal Information</h2>
                <button className="edit-btn" onClick={() => setEditMode(!editMode)}>
                  <FiEdit2 /> {editMode ? 'Cancel' : 'Edit'}
                </button>
              </div>
              <div className="profile-form">
                <div className="form-row-2">
                  <div className="input-group">
                    <label>Full Name</label>
                    <input value={profileData.name} onChange={e => setProfileData(p => ({ ...p, name: e.target.value }))} disabled={!editMode} />
                  </div>
                  <div className="input-group">
                    <label>Email Address</label>
                    <input value={profileData.email} onChange={e => setProfileData(p => ({ ...p, email: e.target.value }))} disabled={!editMode} type="email" />
                  </div>
                </div>
                <div className="form-row-2">
                  <div className="input-group">
                    <label>Phone Number</label>
                    <input value={profileData.phone} onChange={e => setProfileData(p => ({ ...p, phone: e.target.value }))} disabled={!editMode} placeholder="10-digit mobile" />
                  </div>
                  <div className="input-group">
                    <label>Date of Birth</label>
                    <input type="date" value={profileData.dob} onChange={e => setProfileData(p => ({ ...p, dob: e.target.value }))} disabled={!editMode} />
                  </div>
                </div>
                <div className="input-group" style={{ maxWidth: 240 }}>
                  <label>Gender</label>
                  <select value={profileData.gender} onChange={e => setProfileData(p => ({ ...p, gender: e.target.value }))} disabled={!editMode}>
                    <option value="">Select Gender</option>
                    <option value="MALE">Male</option>
                    <option value="FEMALE">Female</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>
                {editMode && (
                  <button className="btn btn-primary" style={{ width: 'fit-content' }} onClick={handleSaveProfile}>
                    Save Changes
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Address Tab */}
          {activeTab === 'address' && (
            <div className="profile-section-card">
              <div className="section-card-header">
                <h2>Saved Addresses</h2>
                <button className="edit-btn" onClick={() => setShowAddAddr(!showAddAddr)}><FiPlus /> Add New</button>
              </div>
              {showAddAddr && (
                <div className="add-addr-form">
                  <div className="form-row-2">
                    <div className="input-group"><label>Full Name *</label><input value={newAddr.name} onChange={e => setNewAddr(p => ({ ...p, name: e.target.value }))} placeholder="Name" /></div>
                    <div className="input-group"><label>Phone *</label><input value={newAddr.phone} onChange={e => setNewAddr(p => ({ ...p, phone: e.target.value }))} placeholder="Phone" /></div>
                  </div>
                  <div className="input-group"><label>Address *</label><input value={newAddr.address} onChange={e => setNewAddr(p => ({ ...p, address: e.target.value }))} placeholder="House No, Street" /></div>
                  <div className="form-row-3">
                    <div className="input-group"><label>City *</label><input value={newAddr.city} onChange={e => setNewAddr(p => ({ ...p, city: e.target.value }))} placeholder="City" /></div>
                    <div className="input-group"><label>State</label><input value={newAddr.state} onChange={e => setNewAddr(p => ({ ...p, state: e.target.value }))} placeholder="State" /></div>
                    <div className="input-group"><label>Pincode *</label><input value={newAddr.pincode} onChange={e => setNewAddr(p => ({ ...p, pincode: e.target.value.replace(/\D/,'').slice(0,6) }))} placeholder="Pincode" maxLength={6} /></div>
                  </div>
                  <div className="addr-type-row" style={{ marginBottom: 16 }}>
                    {['HOME','WORK','OTHER'].map(t => (
                      <button key={t} className={`addr-type-btn${newAddr.type === t ? ' active' : ''}`} onClick={() => setNewAddr(p => ({ ...p, type: t }))}>
                        {t === 'HOME' ? '🏠' : t === 'WORK' ? '🏢' : '📍'} {t}
                      </button>
                    ))}
                  </div>
                  <button className="btn btn-primary btn-sm" onClick={handleAddAddress}>Save Address</button>
                </div>
              )}
              <div className="addresses-grid">
                {addresses.map(addr => (
                  <div key={addr.id} className="address-display-card">
                    <div className="addr-card-header">
                      <span className="addr-type-badge">{addr.type}</span>
                      <div className="addr-card-actions">
                        <button className="addr-action-btn"><FiEdit2 /></button>
                        <button className="addr-action-btn delete" onClick={() => handleDeleteAddress(addr.id)}><FiTrash2 /></button>
                      </div>
                    </div>
                    <p className="addr-card-name">{addr.name} · {addr.phone}</p>
                    <p className="addr-card-full">{addr.address}, {addr.city}, {addr.state} - {addr.pincode}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Settings Tab */}
          {activeTab === 'settings' && (
            <div className="profile-section-card">
              <div className="section-card-header"><h2>Account Settings</h2></div>
              <div className="settings-section">
                <h3>Change Password</h3>
                <div className="form-row-1">
                  <div className="input-group"><label>Current Password</label><input type="password" placeholder="Enter current password" /></div>
                  <div className="input-group"><label>New Password</label><input type="password" placeholder="Min 6 characters" /></div>
                  <div className="input-group"><label>Confirm New Password</label><input type="password" placeholder="Re-enter new password" /></div>
                </div>
                <button className="btn btn-primary btn-sm" onClick={() => toast.success('Password updated!')}>Update Password</button>
              </div>
              <hr className="pd-divider" />
              <div className="settings-section">
                <h3>Notifications</h3>
                <div className="notification-options">
                  {[
                    'Order updates & tracking', 'Promotions & offers', 'Wishlist reminders',
                    'New arrivals', 'Price drop alerts'
                  ].map(n => (
                    <label key={n} className="notification-toggle">
                      <span>{n}</span>
                      <input type="checkbox" defaultChecked className="toggle-input" />
                    </label>
                  ))}
                </div>
              </div>
              <hr className="pd-divider" />
              <div className="settings-section danger-zone">
                <h3>Danger Zone</h3>
                <p>Once you delete your account, there is no going back. Please be certain.</p>
                <button className="btn" style={{ background: 'linear-gradient(135deg,#e11d48,#9f1239)', color: 'white', boxShadow: '0 4px 16px rgba(225,29,72,0.3)' }} onClick={() => toast.error('Feature not available in demo')}>Delete Account</button>
              </div>
            </div>
          )}

          {(activeTab === 'orders' || activeTab === 'wishlist') && (
            <div className="profile-section-card">
              <div className="section-card-header">
                <h2>{activeTab === 'orders' ? 'My Orders' : 'My Wishlist'}</h2>
              </div>
              <div className="redirect-info">
                <p>View your {activeTab === 'orders' ? 'order history' : 'saved items'} on the dedicated page.</p>
                <a href={`/${activeTab}`} className="btn btn-primary btn-sm">Go to {activeTab === 'orders' ? 'Orders' : 'Wishlist'}</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
